import { Link, Skeleton, Typography } from "@crayon/design-system-react";
import { PartnerMigrationState } from "api/client.generated";
import { useSelectedPartnerContext } from "context/selectedPartnerContext";
import usePartnerMigration from "hooks/api/PartnerMigration/usePartnerMigration";
import { useEffect, useState } from "react";
import AppRoutes from "routes/app-routes";

const NewsListNotifications = () => {
  const { migrationData, isMigrationDataLoading } = usePartnerMigration();
  const [textMessage, setTextMessage] = useState("");
  const [linkMessage, setLinkMessage] = useState("");
  const [linkRoute, setLinkRoute] = useState("");
  const { partner } = useSelectedPartnerContext();

  useEffect(() => {
    const setSourcePartnerMessage = (state: PartnerMigrationState) => {
      let txtMessage = "";

      switch (state) {
        case PartnerMigrationState.NotStarted:
          txtMessage = `Migration is available from current Prism partner to '${migrationData?.targetPartner.name}' Cloud-iQ partner. Please sign in to your Cloud-iQ account to proceed.`;
          break;
        case PartnerMigrationState.Completed:
          txtMessage = `Migration is completed from current Prism partner to '${migrationData?.targetPartner.name}' Cloud-iQ partner.`;
          break;
        default:
          txtMessage = `Migration is in progress from current Prism partner to '${migrationData?.targetPartner.name}' Cloud-iQ partner. Please sign in to your Cloud-iQ account to proceed.`;
      }

      setTextMessage(txtMessage);
    };

    const setTargetPartnerMessage = (state: PartnerMigrationState) => {
      let txtMessage = "";
      let lnkRoute = ".";
      let lnkMessage = "";
      switch (state) {
        case PartnerMigrationState.NotStarted:
          txtMessage = `Migration is available from '${migrationData?.sourcePartner.name}' Prism partner to current Cloud-iQ partner.`;
          lnkMessage = "Click to start";
          lnkRoute = AppRoutes.migratePartner.route;
          break;
        case PartnerMigrationState.Completed:
          txtMessage = `Migration is completed from '${migrationData?.sourcePartner.name}' Prism partner to current Cloud-iQ partner.`;
          break;
        default:
          txtMessage = `Migration is in progress from '${migrationData?.sourcePartner.name}' Prism partner to current Cloud-iQ partner.`;
          lnkMessage = "Click to continue";
          lnkRoute = AppRoutes.migratePartner.route;
      }
      setTextMessage(txtMessage);
      setLinkRoute(lnkRoute);
      setLinkMessage(lnkMessage);
    };

    if (!migrationData) setTextMessage("No notifications");

    if (migrationData?.sourcePartner.id.toLowerCase() === partner?.id.toLowerCase())
      setSourcePartnerMessage(migrationData!.state);

    if (migrationData?.targetPartner.id.toLowerCase() === partner?.id.toLowerCase())
      setTargetPartnerMessage(migrationData!.state);
  }, [migrationData, isMigrationDataLoading, partner?.id]);

  if (isMigrationDataLoading) return <Skeleton variant="rounded" />;

  return (
    <Typography variant="body2" testId="migration-msg">
      {textMessage}
      {linkRoute ? (
        <Link href={linkRoute} testId="migration-msg-link">
          {linkMessage}
        </Link>
      ) : undefined}
    </Typography>
  );
};

export default NewsListNotifications;
